import { useState } from 'react';
import SectionLabel from '@/pages/home/components/SectionLabel';
import { topicFilters, topics } from '@/mocks/homeData';

export default function TopicFeed() {
  const [active, setActive] = useState('全部');

  const visibleTopics = active === '全部' ? topics : topics.filter((topic) => topic.category === active);

  return (
    <section id="topics" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionLabel
            index="03"
            kicker="TOPICS · 专题整理"
            title="每一条专题，都是整理好的完整事件"
            desc="人物关系、相关对话、投稿截图与网友反应被放在同一条里，不用再十几个帖子来回翻。"
          />

          <div className="flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 p-1">
            {topicFilters.map((filter) => (
              <button
                key={filter}
                type="button"
                onClick={() => setActive(filter)}
                className={
                  active === filter
                    ? 'whitespace-nowrap rounded-full bg-primary-500 px-3.5 py-1.5 text-sm text-background-50'
                    : 'whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600'
                }
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {visibleTopics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={topic.image}
                  alt={`黑料六点 ${topic.tag} 专题配图`}
                  title={`黑料六点档 ${topic.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2.5 py-1 text-xs text-primary-700">
                  {topic.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {topic.title}
                </h3>
                <p className="mt-2 flex-1 text-sm text-foreground-600">{topic.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">{topic.meta}</span>
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}